// @ts-nocheck
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox";
import { StepFormCommonProps } from "@store/Library/Components/Bunzl/StepFormComponents/StepFormTextField";
import useStepFormInputs from "@store/Library/Components/Bunzl/StepFormComponents/useStepFormInputs";
import getBooleanProperty from "@toolkit/Framework/Common/Utilities/getBooleanProperty";
import React, { SyntheticEvent } from "react";

interface StepFormCheckBoxProps extends CheckboxProps, Omit<StepFormCommonProps, "error"> {
    changeSideEffect?: (value: boolean) => void;
}

const StepFormCheckBox: React.FC<StepFormCheckBoxProps> = ({
    inputKey,
    validation,
    stepOverride,
    hasSubmitted,
    changeSideEffect,
    ...otherProps
}) => {
    const { value, handleChange, editable, error } = useStepFormInputs({
        inputKey,
        required: false,
        validation,
        stepOverride,
    });

    const handleChangeInternal = (event: SyntheticEvent<Element, Event>, value: boolean): void => {
        handleChange(String(value));
        if (changeSideEffect) {
            changeSideEffect(value);
        }
    };
    const booleanError = !!error;
    return (
        <Checkbox
            checked={getBooleanProperty(value)}
            onChange={handleChangeInternal}
            disabled={!editable}
            error={booleanError}
            {...otherProps}
        />
    );
};

export default StepFormCheckBox;
